import * as React from 'react';
import { connect } from 'react-redux';
import BasicAuthSignIn from './BasicAuthSignIn';
import YourPolicy from '../SignUp/YourPolicy';
import { signInWithGoogle, signInWithFacebook, signInWithApple } from '../../actions/authActions';
import { hideMobileProfile } from '../../actions/profileActions';
import SignInSignUpSharedFooter from './SignInSignUpSharedFooter';
import { Button, Image } from 'react-bootstrap';
import './SignInPage.css';

class SignInPage extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            Email: '',
            Password: '',
            submitted: false
        };

        this.handleFacebookLogin = this.handleFacebookLogin.bind(this);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.handleAppleLogin = this.handleAppleLogin.bind(this);
    }

    componentDidMount() {
        this.props.dispatchHideProfile();
    }

    handleFacebookLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.signInWithFacebook()
    }

    handleGoogleLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.signInWithGoogle()
    }

    handleAppleLogin(e: any) {
        e.preventDefault();
        this.setState({ submitted: true });
        this.props.signInWithApple()
    }

    public render() {

        let login =
            <>
                <h2 className="log-in-text">Log in</h2>
                <p className="font-weight-bold mb-0 pb-0">Continue with</p>
                <div className="row">
                    <div className="col-4 col-sm-4 text-center p-0">
                        <Button id="facebook" type="button" className="mt-4 btn" onClick={this.handleFacebookLogin} >
                            <Image src="./Images/icon-facebook.svg" />
                        </Button>
                    </div>
                    <div className="col-4 col-sm-4 text-center p-0">
                        <Button id="google" type="button" className="mt-4 btn" onClick={this.handleGoogleLogin}>
                            <Image src="./Images/icon-google.svg" />
                        </Button>
                    </div>
                    <div className="col-4 col-sm-4 text-center p-0">
                        <Button id="apple" type="button" className="mt-4 btn" onClick={this.handleAppleLogin}>
                            <Image src="./Images/icon-apple.svg" />
                        </Button>
                    </div>
                </div>
                <div className="mt-4 row">
                    <div className="line2 col-lg-5 col-md-5 col-5 ml-3 p-md-0 p-lg-0"></div>
                    <div className="Or col-lg-1 col-md-1 col-1 p-md-0 p-lg-0">Or</div>
                    <div className="line2 col-lg-5 col-md-5 col-5 p-md-0 p-lg-0"></div>
                </div>
                <BasicAuthSignIn />
            </>

        return (
            <>
                <div id="SignInPage" className="row mx-auto pt-5 pb-5">
                    <div className="text-center pt-5 log-in-div mx-auto ml-lg-auto mr-lg-3">
                        {login}
                    </div>
                    <div className="float-left pt-3 mx-auto mr-lg-auto ml-lg-3">
                        <YourPolicy />
                    </div>
                </div>
                <SignInSignUpSharedFooter />
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        signInWithGoogle: () => dispatch(signInWithGoogle()),
        signInWithFacebook: () => dispatch(signInWithFacebook()),
        signInWithApple: () => dispatch(signInWithApple()),
        dispatchHideProfile: () => dispatch(hideMobileProfile())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);